// extracted by mini-css-extract-plugin
module.exports = {"image":"footer-module--image--XcdRN","footer":"footer-module--footer--2r2aa"};